/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const SingleSizeIllustrationFeedbackActiveHappy = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 42"
    data-xds="SingleSizeIllustrationFeedbackActiveHappy"
    role="presentation"
    {...props}
  >
    <g clipPath="url(#clip0_864_210)">
      <path
        fill="#C6F16D"
        d="M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21"
      />
      <path
        fill="#fff"
        d="M14.27 15.847c2.24 0 4.25.99 5.61 2.56a7.4 7.4 0 0 1-5.61 2.56c-2.24 0-4.25-.99-5.61-2.56a7.4 7.4 0 0 1 5.61-2.56M27.36 15.847c2.24 0 4.25.99 5.61 2.56a7.4 7.4 0 0 1-5.61 2.56c-2.24 0-4.25-.99-5.61-2.56a7.4 7.4 0 0 1 5.61-2.56"
      />
      <path
        fill="#1D2124"
        d="M17.19 23.637c2.04 2.4 5.26 2.43 7.24.09l.76.65c-2.39 2.82-6.34 2.77-8.76-.09z"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M14.28 15.347c2.39 0 4.53 1.06 5.99 2.73h-.01l.29.33-.28.33a7.937 7.937 0 0 1-11.98 0l-.29-.33.29-.33a7.94 7.94 0 0 1 5.99-2.73m-.01 1.01a6.92 6.92 0 0 0-4.925 2.054l-.005-.005v.01q.002-.001.005-.005a6.92 6.92 0 0 0 4.925 2.056c.81 0 1.58-.14 2.3-.39a1.786 1.786 0 0 1 0-3.33c-.72-.25-1.49-.39-2.3-.39M27.37 15.347c2.39 0 4.53 1.06 5.99 2.73h-.01l.29.33-.28.33a7.937 7.937 0 0 1-11.98 0l-.29-.33.29-.33a7.94 7.94 0 0 1 5.99-2.73m-.01 1c-1.93 0-3.67.79-4.93 2.06a6.92 6.92 0 0 0 4.93 2.06c.81 0 1.58-.14 2.3-.39a1.79 1.79 0 0 1-1.14-1.67c0-.76.47-1.41 1.14-1.67-.72-.25-1.49-.39-2.3-.39"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="M8.92 12.678c4.86-3.21 8.52-1.001 9.86.109l-.63.77v-.01c-1.46-1.19-4.52-2.79-8.68-.04zM22.23 12.776c1.34-1.1 5-3.319 9.86-.11l-.55.83c-4.16-2.74-7.22-1.15-8.68.04v.01z"
      />
      <path
        fill="#1D2124"
        d="M41 21C41 9.954 32.046 1 21 1S1 9.954 1 21s8.954 20 20 20v1C9.402 42 0 32.598 0 21S9.402 0 21 0s21 9.402 21 21-9.402 21-21 21v-1c11.046 0 20-8.954 20-20"
      />
    </g>
    <defs>
      <clipPath id="clip0_864_210">
        <path fill="#fff" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SingleSizeIllustrationFeedbackActiveHappy;
